import { AUTOFRAME_MAX_VIDEO_DURATION_SECONDS } from '../constants';
import { useEditorState } from '../context/VideoEditorStateContext';

export type UseClipAutoframeConstraintsResult = {
  isTooLongForAutoframe: boolean;
};

export default function useClipAutoframeConstraints(): UseClipAutoframeConstraintsResult {
  const { audioClipDurationSec } = useEditorState();

  return {
    isTooLongForAutoframe:
      audioClipDurationSec > AUTOFRAME_MAX_VIDEO_DURATION_SECONDS,
  };
}
